var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[(_vm.isLogoShow)?_c('img',{staticClass:"header__logo",attrs:{"alt":"logo","src":require("@/assets/icons/logotype.svg")}}):_vm._e(),_c('LanguageSwitcher')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }